<template>
  <div>
    <h3 class="title-page">Все склады</h3>
    <div>
      <div class="warehouses-wrapper">
        <v-row>
          <v-col
            cols="12"
            sm="6"
            md="4"
            lg="3"
            v-for="(item, index) in items"
            :key="`col-${index}`"
          >
            <v-card
              outlined
              height="100%"
              class="warehouse-block cursor-pointer rounded-lg card-shadow"
              @click="
                $router.push({
                  name: 'a-product-omtk',
                  params: { id: item.id },
                })
              "
            >
              <div class="card_content">
                <div class="card_content_left">
                  <v-card-title style="word-break: normal">{{
                    item.name
                  }}</v-card-title>
                  <v-card-subtitle>{{ item.address }}</v-card-subtitle>
                </div>
                <div class="card_content_right">
                  <v-icon class="chevron_icon">mdi-chevron-right</v-icon>
                </div>
              </div>
            </v-card>
          </v-col>
        </v-row>
      </div>
      <vue-pagination
        go-to
        @update:limit="
          (limit) => {
            configuration.limit = limit;
            configuration.page = 1;
            changePage();
          }
        "
        v-model="configuration.page"
        :length="lastPage"
        @input="changePage"
        :limit="configuration.limit"
      />
    </div>
  </div>
</template>

<script>
import { makerPagination } from "@/utils/pureFunctions";
import VuePagination from "@/components/ui/vue-pagination/VuePagination";

export default {
  name: "ware-houses",
  components: { VuePagination },
  data() {
    return {
      items: [],
      configuration: {
        page: 1,
        limit: 20,
      },
      lastPage: 0,
    };
  },
  methods: {
    async getProductItems() {
      const { page, limit } = this.configuration;
      let params = {
        page: page - 1,
        limit,
      };
      try {
        const {
          data: { data, total },
        } = await this.$http.get("warehouse", {
          params,
        });
        this.items = data;
        this.lastPage = makerPagination({ limit, total }).lastPage;
      } catch (e) {
        this.setResponseError({ error: e });
      }
    },
    async changePage(page) {
      const { query: initialQuery } = this.$route;
      const { page: queryPage } = initialQuery;
      if (page.toString() !== queryPage) {
        await this.$router.replace({
          query: { ...initialQuery, page: page.toString() },
        });
      }
      this.showLoading();
      await this.getProductItems();
      this.clearLoading();
    },
  },
  async created() {
    const { page } = this.$route.query;
    if (page && !isNaN(+page)) this.configuration.page = +page;
    this.showLoading();
    await this.getProductItems();
    this.clearLoading();
  },
};
</script>

<style scoped lang="scss">
.card-shadow {
  background-color: #fff !important;
  box-shadow: 0px 1px 2px 0px rgba(1, 51, 8, 0.16);
  border: none;
  padding: 20px 20px;
}

.card-shadow .v-card__title .card-shadow {
  padding: 0px;
}

.card_content {
  display: flex;
  justify-content: space-between;
  align-items: center;

  &_left {
    display: flex;
    flex-direction: column;
  }

  &_right {
    .v-icon {
      transition: 0.3s ease;
      margin-right: 10px;
    }
  }
}

.card-shadow:hover .v-icon.chevron_icon {
  margin-right: 0px;
}
</style>
